import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { BalanceService } from 'src/app/services/balance.service';
import { CartServiceService } from 'src/app/services/cart-service.service';
import { LoginService } from 'src/app/services/login.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { UiServices } from 'src/app/services/ui-services';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { TranslateService } from '@ngx-translate/core';
import { ChangeBranchComponent } from 'src/app/components/change-branch/change-branch.component';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-product-presentation',
  templateUrl: './product-presentation.component.html',
  styleUrls: ['./product-presentation.component.scss'],
})
export class ProductPresentationComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Output() setMedia = new EventEmitter();
  @Output() emitOption = new EventEmitter();
  @Input() data = undefined;
  @Input() type: number = undefined;
  @Input() isService: string = undefined;
  private _isDistributor = undefined;
  private _balanceObs: Subscription = new Subscription();
  private _utliityPrice = undefined;
  private _utilityPricePromo = undefined;
  public currency: any = undefined;
  public contador: number = 1;
  public options = [];
  public showBtn = false;

  public currencyName = 'USD';
  public utility = undefined;
  public buyControl: any = undefined;
  public showContainerBtn = false;
  public availableClient = false;
  public showDistPrice = false;
  public showClientPrice = false;
  public dist: boolean = undefined;
  public client: boolean = undefined;
  public showConsultButton = false;
  public existExistenceClient = undefined;
  public existExistenceDist = undefined;
  public showPriceClient = false;
  public noPrice: any = undefined;
  public noPriceDist: any = undefined;
  public favoriteIcon: string = 'heart-outline';
  public detailOrder = '';
  public typeProduct: 'subscription' | 'service' | 'product' = undefined;
  public showToSuscription = false;

  constructor(
    public cartSv: CartServiceService,
    private balanceSv: BalanceService,
    private uiSv: UiServices,
    private navCtrl: NavController,
    public loginSv: LoginService,
    public paramSv: ParamServicesService,
    private socialSharing: SocialSharing,
    private platform: Platform,
    private trSv: TranslateService,
    private _cdr: ChangeDetectorRef,
    private storageSv: StorageService
  ) {}

  async ngOnInit() {
    if ('inscriptionPrice' in this.data) {
      this.typeProduct = 'subscription';
    } else if ('duration' in this.data) {
      this.typeProduct = 'service';
    } else {
      this.typeProduct = 'product';
    }
    const login = this.loginSv.isLogined.subscribe(() => {
      if (this.buyControl) {
        this.existenceControl();
      }
      login.unsubscribe();
    });
    if (!this.loginSv.user) {
      this.paramSv.existDistributorSignUp = false;
      this.existenceControl();
    } else {
      this.paramSv.existDistributorSignUp =
        this.paramSv.existDistributorSignUpRes;
      this.existenceControl();
    }

    this._balanceObs.add(
      this.paramSv.existDistributorSignUpObs.subscribe((item: any) => {
        if (item) {
          if (!this.loginSv.user) {
            this.paramSv.existDistributorSignUp = false;
          }
        }
        this.existenceControl();
      })
    );

    if (this.paramSv.buyControl) {
      this.buyControl = this.paramSv.buyControl;
      this.existenceControl();
    } else {
      this._balanceObs.add(
        this.paramSv.emitImagesObs.subscribe((item: any) => {
          if (item.name === 'buyControl') {
            this.buyControl = this.paramSv.buyControl;
            this.existenceControl();
          }
        })
      );
    }
    this.contador = 1;
    if (this.balanceSv.currency) {
      this.currency = this.balanceSv.currency;
      this.setCurrencyChange(this.balanceSv.currency);
    }
    this._balanceObs.add(
      this.balanceSv.currencySource.subscribe((res) => {
        this.currency = res;
        this.setCurrencyChange(this.currency);
      })
    );

    if (this.data?.options?.length) {
      this.options.push(this.data);
      this.data.options.map((item) => {
        this.options.push(item);
      });
    }
    this.verifyFavorite();
    this.verifySessionStorage();
  }

  ngAfterViewInit(): void {
    // const ogTitle = document.getElementById('og-title') as HTMLElement;
    // this.renderer.setAttribute(ogTitle, 'content', this.data.name);
    this.data.notCanAdd = false;
    if (this.data?.grupoOptions) {
      for (const group of this.data?.grupoOptions) {
        if (group.min) {
          this.data.notCanAdd = true;
          break;
        }
      }
    }

    setTimeout(() => {
      this.currency = this.balanceSv?.currency;
      this.currencyName =
        this.currency?.symbol || this.balanceSv.currencyBaseName;
      this._cdr.detectChanges();
    });
  }

  goToCart() {
    this.navCtrl.navigateRoot('cart');
  }

  async goToSponsor(id) {
    await this.navCtrl.navigateForward(`sponsors/${id}`);
  }

  verifyFavorite() {
    this.favoriteIcon = this.cartSv.verifyFavorite(this.data);
  }

  async addFavorite() {
    try {
      const { favoriteIcon, favorite } = await this.cartSv.addFavorite(
        this.data
      );
      this.favoriteIcon = favoriteIcon;
      this.data.favorite = favorite;
    } catch (err) {
      console.error(err);
    }
  }

  existenceControl() {
    this.noPrice = !this.data.price && !this.data?.promotionalPrice;
    if (this.typeProduct === 'product') {
      this.dist = this.cartSv.dist;
      this.client = this.cartSv.client;
      this.noPriceDist =
        !this.data.price &&
        !this.data.priceWSale &&
        !this.data.promotionalPrice &&
        !this.data.promotionalPriceWSale;
      this.existExistenceClient =
        this.data.existence > 0 ||
        this.data.existence === null ||
        (this.data.existence === 0 && this.data.countHidden);
      this.existExistenceDist =
        ((this.data.existenceWSale > 0 || this.data.existence === null) &&
          !this.existExistenceClient) ||
        (this.data.existenceWSale === 0 && this.data.countHidden);
      if (!this.loginSv.userVerified) {
        return;
      }

      if (
        this.client &&
        (this.data?.existence === null ||
          this.data?.existence > 0 ||
          (this.data?.existence === 0 && this.data?.countHidden))
      ) {
        this.showBtn = true;
      } else if (
        this.dist &&
        (this.data?.existenceWSale === null ||
          this.data?.existenceWSale > 0 ||
          (this.data?.existenceWSale === 0 && this.data?.countHidden) ||
          this.data?.existence === null ||
          this.data?.existence > 0 ||
          (this.data?.existence === 0 && this.data?.countHidden))
      ) {
        this.showBtn = true;
      } else if ('inscriptionPrice' in this.data) {
        this.showBtn = true;
      }

      if (
        this.dist &&
        (this.data.priceWSale || this.data.promotionalPriceWSale)
      ) {
        this.showDistPrice = true;
      }

      if (this.data.price || this.data.promotionalPrice) {
        this.showClientPrice = true;
      }

      if (this.client) {
        if (this.existExistenceClient) {
          this.showContainerBtn = true;
        }
      } else if (this.dist) {
        if (this.existExistenceDist) {
          this.showContainerBtn = true;
        } else if (this.existExistenceClient) {
          this.showContainerBtn =
            this.existExistenceClient && !this.noPrice ? true : false;
          this.showDistPrice = false;
          if ('existence' in this.data) {
            this.availableClient = this.data.existence === null ? false : true;
          } else {
            this.availableClient = false;
          }
        }
      }

      //Mostrar precio de cliente si soy distribuidor
      if (this.dist && !this.noPrice) {
        this.showPriceClient = true;
      } else if (this.client) {
        this.showPriceClient = true;
      }

      // Ocultar botones de agregar,
      // mostrar consultar si es necesario,
      // o mostrar producto agotado
      this.noPriceDist =
        this.data.existenceWSale === 0 &&
        !this.data.countHidden &&
        !this.noPriceDist
          ? true
          : this.noPriceDist;

      if (this.dist && this.noPriceDist && this.noPrice) {
        this.showConsultButton = true;
        this.showContainerBtn = false;
      } else if (this.client && this.noPrice) {
        this.showConsultButton = true;
        this.showContainerBtn = false;
      }

      if (!this.existExistenceClient) {
        this.showContainerBtn = false;
      }
      if (!this.existExistenceDist && !this.existExistenceClient && this.dist) {
        this.showContainerBtn = false;
      }

      if (this.buyControl) {
        if (this.dist) {
          if (
            !this.data.priceWSale &&
            !this.data.promotionalPriceWSale &&
            this.data.existence !== null
          ) {
            if ('existence' in this.data) {
              this.availableClient = true;
            } else {
              this.availableClient = false;
            }
          } else if (
            this.existExistenceClient &&
            this.data.existence !== null
          ) {
            if ('existence' in this.data) {
              this.availableClient = true;
            } else {
              this.availableClient = false;
            }
          }
        } else if (
          this.buyControl.inventoryClient &&
          this.data.existence !== null
        ) {
          if ('existence' in this.data) {
            this.availableClient = true;
          } else {
            this.availableClient = false;
          }
        }
      }
    } else {
      this.showContainerBtn = true;
      this.showBtn = true;
      if (!this.noPrice) {
        this.showPriceClient = true;
      } else if (this.client) {
        this.showPriceClient = true;
      }
      if (
        this.data?.price ||
        this.data?.promotionalPrice ||
        this.data?.inscriptionPrice
      ) {
        this.showClientPrice = true;
      }
      if ('frequency' in this.data) {
        this.showToSuscription = true;
        this.data.quantity = 1;
        this.showContainerBtn = false;
      }
    }
  }

  async showExistenceAlert() {
    if (
      (this.buyControl?.showModalExistence &&
        this.client &&
        this.existExistenceClient &&
        this.data.existence === 0) ||
      (this.dist && this.existExistenceDist && this.data.existenceWSale === 0)
    ) {
      const { role } = await this.uiSv.presentAlert(
        this.buyControl?.modalMessage
      );
      if (role === 'accept') {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  ngOnDestroy(): void {
    this._balanceObs.unsubscribe();
  }

  async setCurrencyChange(currency) {
    this.currencyName = currency?.symbol || this.balanceSv.currencyBaseName;

    this._utliityPrice =
      this.data.price -
      (this.data.promotionalPriceWSale || this.data.priceWSale);
    this._utilityPricePromo =
      this.data.promotionalPrice - this.data.promotionalPriceWSale;

    if (this._utilityPricePromo > 0) {
      this.utility = this._utilityPricePromo;
    } else if (this._utliityPrice > 0) {
      this.utility = this._utliityPrice;
    }
  }

  async countProduct(count) {
    this.contador = count;
    this.data.quantity = this.contador;
  }

  async openWpp(num?) {
    const numWpp = num?.detail?.value || this.paramSv.numWpp;
    window.open(
      `https://wa.me/${numWpp}?text=${this.paramSv.msgWpp}`,
      '_blank'
    );
  }

  setOption(option) {
    this.data = undefined;
    this.contador = 1;
    setTimeout(() => {
      this.emitOption.emit(option.id);
    }, 100);
  }

  async add() {
    try {
      if (this.buyControl?.showModalExistence) {
        const opt = await this.showExistenceAlert();
        if (!opt) {
          this.contador = 1;
          return false;
        }
      }

      if (this.paramSv.dispatch?.branch) {
        if (!this.loginSv.branchContactId) {
          const defaultTxt =
            this.paramSv.dispatch.branchMsg ||
            this.trSv.instant(
              'DEBES_SELECCIONAR_UNA_SUCURSAL_ANTES_DE_CONTINUAR'
            );
          this.showAvailableBranch(defaultTxt);
          return;
        } else if (
          this.data.inventory.find(
            (branch) => branch.branchContactId === this.loginSv.branchContactId
          ).existence === 0
        ) {
          const defaultTxt =
            this.paramSv.dispatch.branchUnavailableMsg ||
            this.trSv.instant(
              'EL_PRODUCTO_NO_ESTA_DISPONIBLE_EN_ESTA_SUCURSAL'
            );
          this.showAvailableBranch(defaultTxt);
          return;
        }
      }

      this._isDistributor =
        this.paramSv.existDistributorSignUp && this.loginSv?.user?.rolId === 7
          ? true
          : false;
      this.data.detail = this.detailOrder
        ? `${this.data.quantity} - ${this.detailOrder} \n`
        : '';
      this.data.branchContactId = this.loginSv.branchContactId;
      await this.cartSv.addCart(this.data, true, this._isDistributor);
      this.detailOrder = '';
      this.contador = 1;
    } catch (err) {
      this.contador = 1;
      console.error(err);
    }
  }

  async showAvailableBranch(defaultTxt) {
    const { role } = await this.uiSv.presentAlert(
      defaultTxt,
      false,
      'CONTINUAR',
      false
    );
    if (role === 'accept') {
      const { data } = await this.uiSv.showPopover(
        ChangeBranchComponent,
        {
          availableBranch: this.data.inventory,
        },
        'branch-pop'
      );
      if (data) {
        this.storageSv.setSessionStorage('quantity', this.contador.toString());
        this.storageSv.setSessionStorage('detailOrder', this.detailOrder);
        this.storageSv.setSessionStorage(
          'additionals',
          JSON.stringify(this.data.grupoOptions)
        );
      }
    }
  }

  verifySessionStorage() {
    const quantity = this.storageSv.getSessionStorage('quantity');
    const detailOrder = this.storageSv.getSessionStorage('detailOrder');
    const additionals = this.storageSv.getSessionStorage('additionals');
    if (quantity) {
      this.contador = parseInt(quantity, 10);
      this.data.quantity = this.contador;
    }
    if (detailOrder) {
      this.detailOrder = detailOrder;
    }
    if (additionals && additionals !== 'undefined') {
      this.data.grupoOptions = JSON.parse(additionals);
      this.data.grupoOptions.forEach((item) => {
        item.option.forEach((option) => {
          if (option.checked) {
            this.cartSv.calcPriceOptions(this.data, {
              restPrice: 0,
              price: option.promotionalPrice || option.price,
            });
            this._cdr.detectChanges();
          }
        });
      });
    }

    sessionStorage.clear();
  }

  async share() {
    if (this.platform.is('capacitor')) {
      // const text = `${this.data?.name}
      // ${this.data.price}
      // ${this.data?.description}`;
      const text = this.trSv.instant('VER_MAS');
      this.socialSharing.share(
        text,
        this.data?.name,
        null,
        window.localStorage.href
      );
    } else {
      const seeMore = this.trSv.instant('VER_MAS');
      const data: ShareData = {
        url: window.location.href,
        title: this.data?.name || '',
        text: seeMore,
      };
      const nav = navigator;
      if ('share' in navigator) {
        await navigator.share(data);
      } else {
        nav.clipboard.writeText(window.location.href);
        await this.uiSv.showToast('El enlace se ha copiado al portapapeles.');
      }
    }
  }

  setGroup(ev) {
    this.data.additionals = ev.additionals;
    this.cartSv.calcPriceOptions(this.data, ev);
    this.data.notCanAdd = ev.notCanAdd;
    this._cdr.detectChanges();
  }

  async goToCalendar() {
    if (!this.loginSv.user) {
      const content = this.trSv.instant('DEBES_INICIAR_SESION_PARA_CONTINUAR');
      const { role } = await this.uiSv.presentAlert(
        content,
        false,
        'ACEPTAR',
        false
      );
      if (role === 'accept') {
        await this.navCtrl.navigateRoot('auth');
      }
      return;
    }
    await this.navCtrl.navigateForward(`/meeting/${this.data.id}`);
  }
}
